// @flow
import client from '../../client'

// Types
import type { TTravelAgent } from './register'

// API Endpoints
export const TRAVEL_AGENT_ENDPOINT = '/travel_agent/'

/**
 * Updates a travel agent profile
 * @param {Object} data Travel agent information
 * @param {string} data.tax_id Tax id
 * @param {string} data.currency Currency
 * @param {number} data.comission Commision
 * @returns {Promise<TTravelAgent> | Error} A resolved Promise with the profile updated or Rejected with an Error
 */
export const updateProfile = (data: {
  tax_id: string,
  currency: string,
  comission: number,
}): Promise<TTravelAgent> => client.patch(TRAVEL_AGENT_ENDPOINT, { body: data })

export default updateProfile
